/**
 * Shared full-width hero shell: depth, mesh light, optional workshop photo, technical grid.
 */
export function brandHeroSection(theme, backgroundImage, imagePosition = 'center') {
  const { primary } = theme.palette;
  return {
    position: 'relative',
    overflow: 'hidden',
    color: primary.contrastText,
    py: { xs: 9, md: 15 },
    background: `linear-gradient(125deg, ${primary.dark} 0%, ${primary.main} 42%, #232a9c 70%, #0d1158 100%)`,
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: imagePosition,
      opacity: 0.26,
      mixBlendMode: 'overlay',
      zIndex: 0,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      zIndex: 0,
      pointerEvents: 'none',
      background: `
        radial-gradient(ellipse 90% 55% at 100% -5%, rgba(241, 196, 0, 0.48), transparent 52%),
        radial-gradient(ellipse 70% 50% at -5% 105%, rgba(120, 130, 255, 0.42), transparent 48%),
        radial-gradient(ellipse 50% 40% at 50% 50%, rgba(255, 120, 80, 0.08), transparent 60%),
        repeating-linear-gradient(
          108deg,
          transparent 0,
          transparent 14px,
          rgba(255, 255, 255, 0.035) 14px,
          rgba(255, 255, 255, 0.035) 15px
        )
      `,
    },
  };
}

export const heroContentZ = { position: 'relative', zIndex: 1 };
